import { render } from "./LayoutComponent.vue?vue&type=template&id=244b8fd5"
import script from "./LayoutComponent.vue?vue&type=script&lang=js"
export * from "./LayoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__